// @flow
import React from 'react';
import cx from 'classnames';
import pluralize from 'pluralize';

import Checkbox from 'components/Checkbox';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  onClick: Function,
  icon: string,
  personCount: number,
  checked: boolean,
  enabled: boolean,
  roleType: 'student' | 'parent',
  orphanCount?: number,
};

export default class TargetByStudentIdSelectPageRole extends React.Component<Props, *> {
  handleClick = (event: SyntheticEvent<>) => {
    event.preventDefault();
    this.props.onClick();
  };

  render() {
    const { icon, checked, enabled, personCount, roleType, orphanCount } = this.props;
    const personCountString = `${personCount} ${pluralize('person', personCount)}`;

    return (
      <div
        className={cx('TargetByStudentIdSelectPage-sidebar-role', {
          'TargetByStudentIdSelectPage-sidebar-role--enabled': enabled,
        })}
        onClick={enabled ? this.handleClick : () => {}}
        data-test="parent-div">
        <MediaObject figure="right" gutter="xxsmall">
          <MediaObject gutter="small">
            <Image src={icon} width={20} className="TargetByStudentIdSelectPage-sidebar-roleIcon" />
            <div>
              <Text element="div" size="small">
                {roleType === 'student' ? 'Students' : 'Parents and Guardians'}
              </Text>
              {orphanCount ? (
                <React.Fragment>
                  <Row size="xsmall">
                    <Text element="div" color="eclipse" size="xsmall">
                      {personCountString}
                    </Text>
                  </Row>
                  {!!orphanCount && (
                    <Text color="lava" size="xsmall">
                      Missing from {orphanCount} {pluralize('student', orphanCount)}
                    </Text>
                  )}
                </React.Fragment>
              ) : (
                <Text element="div" color="eclipse" size="xsmall">
                  {personCountString}
                </Text>
              )}
            </div>
          </MediaObject>
          <Checkbox
            onChange={enabled ? this.handleClick : () => {}}
            data-test={`${roleType}-checkbox`}
            checked={checked}
            disabled={!enabled}
          />
        </MediaObject>
      </div>
    );
  }
}
